module.exports = __webpack_public_path__ + "img/mbp-16-arch.73dac811.webp";